export const LANGUAGE_PAGES = {
  es: {
    lang: 'es',
    name: 'Spanish',
    title: 'Lectura de Tarot con IA en Español | NowTarot AI',
    description: 'Haz tu pregunta de tarot en español y recibe una respuesta clara del lector de tarot con IA.',
    examples: ['¿Encontraré el amor este año?', '¿Debo aceptar este trabajo?', '¿Qué necesito saber ahora?'],
    button: 'Preguntar',
    loading: 'Sacando cartas...',
  },
  hi: {
    lang: 'hi',
    name: 'Hindi',
    title: 'Hindi AI Tarot Reading | NowTarot AI',
    description: 'हिंदी में अपना टैरो सवाल पूछें और AI tarot reader से स्पष्ट मार्गदर्शन पाएं.',
    examples: ['क्या मुझे यह नौकरी लेनी चाहिए?', 'मेरे रिश्ते में आगे क्या होगा?', 'मुझे अभी क्या जानना चाहिए?'],
    button: 'पूछें',
    loading: 'कार्ड निकाले जा रहे हैं...',
  },
  zh: {
    lang: 'zh',
    name: 'Chinese',
    title: '中文 AI 塔罗牌解读 | NowTarot AI',
    description: '用中文提出塔罗问题，并从 AI 塔罗读者获得清晰指引。',
    examples: ['我今年会遇到爱情吗？', '我应该接受这份工作吗？', '我现在需要知道什么？'],
    button: '提问',
    loading: '正在抽牌...',
  },
  ar: {
    lang: 'ar',
    dir: 'rtl',
    name: 'Arabic',
    title: 'قراءة تاروت بالذكاء الاصطناعي بالعربية | NowTarot AI',
    description: 'اكتب سؤالك عن التاروت بالعربية واحصل على إرشاد واضح من قارئ تاروت يعمل بالذكاء الاصطناعي.',
    examples: ['هل سأجد الحب هذا العام؟', 'هل يجب أن أقبل هذه الوظيفة؟', 'ما الذي أحتاج إلى معرفته الآن؟'],
    button: 'اسأل',
    loading: 'يتم سحب البطاقات...',
  },
  fr: {
    lang: 'fr',
    name: 'French',
    title: 'Lecture de Tarot IA en Français | NowTarot AI',
    description: 'Posez votre question de tarot en français et recevez une réponse claire du lecteur de tarot IA.',
    examples: ["Vais-je trouver l'amour cette année ?", 'Dois-je accepter ce travail ?', "Que dois-je comprendre maintenant ?"],
    button: 'Demander',
    loading: 'Tirage des cartes...',
  },
  pt: {
    lang: 'pt',
    name: 'Portuguese',
    title: 'Leitura de Tarô com IA em Português | NowTarot AI',
    description: 'Faça sua pergunta de tarô em português e receba orientação clara do leitor de tarô com IA.',
    examples: ['Vou encontrar amor este ano?', 'Devo aceitar este trabalho?', 'O que preciso saber agora?'],
    button: 'Perguntar',
    loading: 'Tirando as cartas...',
  },
  de: {
    lang: 'de',
    name: 'German',
    title: 'KI-Tarotlegung auf Deutsch | NowTarot AI',
    description: 'Stelle deine Tarotfrage auf Deutsch und erhalte klare Orientierung vom KI-Tarotleser.',
    examples: ['Finde ich dieses Jahr Liebe?', 'Soll ich den neuen Job annehmen?', 'Was muss ich jetzt wissen?'],
    button: 'Fragen',
    loading: 'Karten werden gezogen...',
  },
  ja: {
    lang: 'ja',
    name: 'Japanese',
    title: '日本語 AI タロット占い | NowTarot AI',
    description: '日本語でタロットの質問を入力し、AI タロットリーダーからわかりやすい答えを受け取れます。',
    examples: ['今年、恋愛はありますか？', 'この仕事を受けるべきですか？', '今知るべきことは何ですか？'],
    button: '質問する',
    loading: 'カードを引いています...',
  },
  ko: {
    lang: 'ko',
    name: 'Korean',
    title: 'AI 타로 — 무료 한국어 타로 리딩 | NowTarot AI',
    description: '한국어로 타로 질문을 하고 AI 타로 리더에게 분명한 답을 받아보세요.',
    examples: ['올해 사랑을 만날 수 있을까요?', '이 직장을 받아들여야 할까요?', '지금 내가 알아야 할 것은 무엇인가요?'],
    button: '질문하기',
    loading: '카드를 뽑는 중...',
  },
  it: {
    lang: 'it',
    name: 'Italian',
    title: 'Lettura dei Tarocchi con IA in Italiano | NowTarot AI',
    description: 'Fai la tua domanda di tarocchi in italiano e ricevi una risposta chiara dal lettore di tarocchi IA.',
    examples: ['Troverò l’amore quest’anno?', 'Dovrei accettare questo lavoro?', 'Cosa devo sapere adesso?'],
    button: 'Chiedi',
    loading: 'Sto pescando le carte...',
  },
  tr: {
    lang: 'tr',
    name: 'Turkish',
    title: 'Türkçe Yapay Zeka Tarot Falı | NowTarot AI',
    description: 'Tarot sorunuzu Türkçe sorun ve yapay zeka tarot falcısından net bir yanıt alın.',
    examples: ['Bu yıl aşkı bulacak mıyım?', 'Bu işi kabul etmeli miyim?', 'Şimdi neyi bilmem gerekiyor?'],
    button: 'Sor',
    loading: 'Kartlar çekiliyor...',
  },
  id: {
    lang: 'id',
    name: 'Indonesian',
    title: 'Bacaan Tarot AI dalam Bahasa Indonesia | NowTarot AI',
    description: 'Ajukan pertanyaan tarot dalam bahasa Indonesia dan dapatkan panduan jelas dari pembaca tarot AI.',
    examples: ['Apakah aku akan menemukan cinta tahun ini?', 'Haruskah aku menerima pekerjaan ini?', 'Apa yang perlu aku ketahui sekarang?'],
    button: 'Tanya',
    loading: 'Mengambil kartu...',
  },
  pl: {
    lang: 'pl',
    name: 'Polish',
    title: 'Wróżba Tarot AI po Polsku | NowTarot AI',
    description: 'Zadaj pytanie tarota po polsku i otrzymaj jasną odpowiedź od czytnika tarota AI.',
    examples: ['Czy znajdę miłość w tym roku?', 'Czy warto przyjąć tę pracę?', 'Co muszę wiedzieć teraz?'],
    button: 'Zapytaj',
    loading: 'Dobieranie kart...',
  },
  vi: {
    lang: 'vi',
    name: 'Vietnamese',
    title: 'Xem Bài Tarot AI bằng Tiếng Việt | NowTarot AI',
    description: 'Đặt câu hỏi tarot bằng tiếng Việt và nhận hướng dẫn rõ ràng từ trình đọc tarot AI.',
    examples: ['Năm nay tôi có gặp tình yêu không?', 'Tôi có nên nhận công việc này không?', 'Bây giờ tôi cần biết điều gì?'],
    button: 'Hỏi',
    loading: 'Đang rút bài...',
  },
  th: {
    lang: 'th',
    name: 'Thai',
    title: 'ดูดวงไพ่ทาโรต์ AI ภาษาไทย | NowTarot AI',
    description: 'ถามคำถามไพ่ทาโรต์เป็นภาษาไทย แล้วรับคำแนะนำที่ชัดเจนจากนักอ่านไพ่ทาโรต์ AI',
    examples: ['ปีนี้ฉันจะได้พบรักไหม?', 'ฉันควรรับงานนี้ไหม?', 'ตอนนี้ฉันควรรู้เรื่องอะไร?'],
    button: 'ถาม',
    loading: 'กำลังจั่วไพ่...',
  },
  nl: {
    lang: 'nl',
    name: 'Dutch',
    title: 'AI-tarotlegging in het Nederlands | NowTarot AI',
    description: 'Stel je tarotvraag in het Nederlands en krijg duidelijke begeleiding van de AI-tarotlezer.',
    examples: ['Vind ik dit jaar de liefde?', 'Moet ik deze baan aannemen?', 'Wat moet ik nu weten?'],
    button: 'Vragen',
    loading: 'Kaarten worden getrokken...',
  },
  ru: {
    lang: 'ru',
    name: 'Russian',
    title: 'ИИ-таро на русском | NowTarot AI',
    description: 'Задайте вопрос Таро на русском и получите ясный ответ от ИИ-таролога.',
    examples: ['Найду ли я любовь в этом году?', 'Стоит ли принимать эту работу?', 'Что мне нужно знать сейчас?'],
    button: 'Спросить',
    loading: 'Вытягиваем карты...',
  },
  fil: {
    lang: 'fil',
    name: 'Filipino',
    title: 'Pagbasa ng Tarot ng AI sa Filipino | NowTarot AI',
    description: 'Itanong ang iyong tarot question sa Filipino at makakuha ng malinaw na sagot mula sa AI tarot reader.',
    examples: ['Makakahanap ba ako ng pag-ibig ngayong taon?', 'Dapat ko bang tanggapin ang trabahong ito?', 'Ano ang kailangan kong malaman ngayon?'],
    button: 'Magtanong',
    loading: 'Hinihila ang mga baraha...',
  },
  uk: {
    lang: 'uk',
    name: 'Ukrainian',
    title: 'ШІ-таро українською | NowTarot AI',
    description: 'Поставте питання Таро українською та отримайте ясну відповідь від ШІ-таролога.',
    examples: ['Чи знайду я кохання цього року?', 'Чи варто приймати цю роботу?', 'Що мені потрібно знати зараз?'],
    button: 'Запитати',
    loading: 'Витягуємо карти...',
  },
  ro: {
    lang: 'ro',
    name: 'Romanian',
    title: 'Citire de Tarot cu IA în Română | NowTarot AI',
    description: 'Pune-ți întrebarea de tarot în română și primește un răspuns clar de la cititorul de tarot cu IA.',
    examples: ['Voi găsi dragostea anul acesta?', 'Ar trebui să accept jobul acesta?', 'Ce trebuie să știu acum?'],
    button: 'Întreabă',
    loading: 'Se trag cărțile...',
  },
  sv: {
    lang: 'sv',
    name: 'Swedish',
    title: 'AI-tarotläsning på svenska | NowTarot AI',
    description: 'Ställ din tarotfråga på svenska och få ett tydligt svar från AI-tarottolkaren.',
    examples: ['Kommer jag att hitta kärleken i år?', 'Ska jag ta det här jobbet?', 'Vad behöver jag veta nu?'],
    button: 'Fråga',
    loading: 'Korten dras...',
  },
  cs: {
    lang: 'cs',
    name: 'Czech',
    title: 'AI výklad tarotu česky | NowTarot AI',
    description: 'Položte tarotovou otázku česky a získejte jasnou odpověď od AI tarotového vykladače.',
    examples: ['Najdu letos lásku?', 'Mám přijmout tuhle práci?', 'Co teď potřebuji vědět?'],
    button: 'Zeptat se',
    loading: 'Vytahujeme karty...',
  },
  el: {
    lang: 'el',
    name: 'Greek',
    title: 'Ταρώ με Τεχνητή Νοημοσύνη στα Ελληνικά | NowTarot AI',
    description: 'Κάντε την ερώτηση ταρώ στα ελληνικά και λάβετε σαφή απάντηση από τον αναγνώστη ταρώ με τεχνητή νοημοσύνη.',
    examples: ['Θα βρω έρωτα φέτος;', 'Πρέπει να δεχτώ αυτή τη δουλειά;', 'Τι πρέπει να ξέρω τώρα;'],
    button: 'Ρωτήστε',
    loading: 'Τραβάμε τα φύλλα...',
  },
  hu: {
    lang: 'hu',
    name: 'Hungarian',
    title: 'AI tarot olvasás magyarul | NowTarot AI',
    description: 'Tedd fel tarotkérdésed magyarul, és kapj világos választ az AI tarotolvasótól.',
    examples: ['Találok idén szerelmet?', 'Elfogadjam ezt a munkát?', 'Mit kell most tudnom?'],
    button: 'Kérdezz',
    loading: 'Kártyákat húzunk...',
  },
};

export function askBoxProps(lang) {
  const page = LANGUAGE_PAGES[lang];
  if (!page) return {};
  return {
    language: page.lang,
    typewriter: page.examples,
    askLabel: page.button,
    drawingLabel: page.loading,
  };
}
